import $ from 'jquery';
import AccountService from '../_shared/account-service';

export default class PremiumContent {
  constructor() {
    this.$premiumContent = $('.js-premium-content');
    this.$signInRequired = $('.js-sign-in-required');

    this.init();
  }

  async init() {
    this.isInitialized = true;

    if (!this.$signInRequired.length && !this.$premiumContent.length) {
      this.isInitialized = false;

      return;
    }

    try {
        const isAuthenticated = await AccountService.isAuthenticated();

        if (isAuthenticated) {
            this.$signInRequired.removeClass('signed-out');
            this.$signInRequired.addClass('signed-in');
        }

      let hasSubscription;
      const userData = await AccountService.getUserData();
      if (userData) {
        hasSubscription = await AccountService.isPremiumUser(userData.id);
      }

      if (hasSubscription) {
        this.$premiumContent.addClass('is-eligible');
      } else {
        console.warn('User doesn\'t have a subscription!');
      }
    } catch (e) {
      console.error(`An error occurred during validation of user subscription: ${e}`);
    }
  }
}
